/* import __COLOCATED_TEMPLATE__ from './custom-bot-type-selector.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();